<template>
    <div class="calendar-filters" role="region" aria-label="Event filters" v-if="filters.length">
        <h2 class="calendar-filters__title">Filter</h2>
        <div class="calendar-filters__container">
            <template v-for="(filter, index) in filters" :key="index">
                <details
                    v-if="filter.facets.length && filter.checkboxGroup"
                    class="calendar-filters__fieldset"
                    :open="filter.isOpen"
                >
                    <summary class="calendar-filters__summary">
                        {{ filter.title }}
                    </summary>
                    <fieldset class="calendar-filters__group">
                        <legend class="visually-hidden">Filter by {{ filter.title }}</legend>
                        <div class="calendar-filters__options">
                            <label v-for="facet in filter.facets" :key="facet.title" class="calendar-filters__label"
                                :class="{ 'is-disabled': facet.isDisabled }">
                                <input type="checkbox" :checked="facet.isChecked" :disabled="facet.isDisabled"
                                    @change="updateFacet(filter, facet)" class="calendar-filters__checkbox" />
                                <span>{{ facet.title }}</span>
                            </label>
                        </div>
                    </fieldset>
                </details>
            </template>

            <template v-for="(filter, index) in filters" :key="index">
                <label
                    class="calendar-filters__toggle"
                    v-if="!filter.checkboxGroup && filter.facets.length"
                >
                    <span class="calendar-filters__label">
                        <svg v-if="filter.name === 'accessClub'" xmlns="http://www.w3.org/2000/svg" width="85" height="43" viewBox="0 0 85 43" fill="none">
                            <g clip-path="url(#clip0_5608_6179)">
                                <mask id="mask0_5608_6179" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="85" height="43">
                                <path d="M85 0H0V43H85V0Z" fill="white"/>
                                </mask>
                                <g mask="url(#mask0_5608_6179)">
                                <path d="M20.6135 5.85603H20.6328L22.0928 9.02409H19.1727L20.6135 5.85603ZM14.5259 13.631H16.6381C17.022 13.631 17.2339 13.3998 17.3288 13.1701L18.021 11.6335H23.2445L23.9352 13.1509C24.1086 13.5154 24.2613 13.631 24.6082 13.631H26.7396C27.0272 13.631 27.1814 13.3805 27.0657 13.1316L25.8147 10.4422C27.0183 12.4737 29.2387 13.8236 31.7912 13.8236C33.5002 13.8236 35.1515 13.2279 36.4573 11.961C36.5922 11.8261 36.6115 11.5772 36.4766 11.4424L34.978 9.84944C34.8624 9.7146 34.6134 9.7146 34.4785 9.83018C33.7878 10.4259 32.808 10.7519 31.9053 10.7519C29.7353 10.7519 28.1211 8.98556 28.1211 6.85475C28.1211 4.72394 29.7145 2.89986 31.886 2.89986C32.8273 2.89986 33.7685 3.24512 34.4785 3.87932C34.6134 4.01416 34.8239 4.01416 34.9588 3.87932L36.4558 2.32492C36.61 2.17082 36.61 1.94114 36.4366 1.78704C35.1337 0.595679 33.7122 0 31.7912 0C27.9507 0 24.8587 3.09101 24.8587 6.93032C24.8587 7.73493 24.9965 8.50398 25.2455 9.2182L21.0552 0.211896C20.9974 0.0963162 20.864 0 20.7291 0H20.5364C20.4015 0 20.2681 0.0963162 20.2103 0.211896L14.1998 13.1331C14.0841 13.382 14.2383 13.6324 14.5259 13.6324" fill="black"/>
                                <path d="M42.0679 2.89841C43.0092 2.89841 43.9504 3.24367 44.6604 3.87787C44.7938 4.01272 45.0058 4.01272 45.1406 3.87787L46.2553 2.7206V11.0142L45.1599 9.84948C45.0443 9.71463 44.7953 9.71463 44.6604 9.83021C43.9682 10.4259 42.9899 10.7519 42.0872 10.7519C39.9172 10.7519 38.303 8.9856 38.303 6.85478C38.303 4.72397 39.8979 2.89989 42.0679 2.89989M49.2509 8.21803H53.6295C53.8222 8.21803 53.9942 8.06392 53.9942 7.85351V5.76123C53.9942 5.56859 53.8207 5.39671 53.6295 5.39671H49.2509V3.01547H54.0505C53.9912 3.28071 53.9571 3.55188 53.9571 3.82156C53.9571 6.12575 56.0308 7.41194 57.6835 8.06392C58.9894 8.58255 59.6623 9.19749 59.6623 10.0036C59.6623 10.6763 59.105 11.1549 58.3372 11.1549C57.0698 11.1549 55.6869 10.1369 55.6098 10.0984C55.4749 10.0021 55.1103 9.96358 54.9561 10.214L54.6167 10.8141C54.6019 10.8126 54.5871 10.8097 54.5722 10.8097H49.2524V8.21803H49.2509ZM58.2393 2.63021C59.4103 2.63021 60.8125 3.68672 60.986 3.78304C61.1594 3.91788 61.5047 3.74451 61.6382 3.53262L61.8457 3.21848C61.8131 3.41852 61.7923 3.61856 61.7923 3.82008C61.7923 6.12426 63.866 7.41046 65.5187 8.06244C66.8246 8.58107 67.4975 9.19601 67.4975 10.0021C67.4975 10.6748 66.9402 11.1535 66.1724 11.1535C64.905 11.1535 63.5221 10.1355 63.445 10.0969C63.3531 10.0317 63.1575 9.99617 62.9915 10.0554C62.9959 9.9858 63.0033 9.91616 63.0033 9.84651C63.0033 7.2356 60.6213 6.06499 59.1242 5.46931C57.6079 4.85437 57.0313 4.31796 57.0313 3.60671C57.0313 3.08808 57.5501 2.62724 58.2408 2.62724M41.9716 13.8236C43.5176 13.8236 45.0161 13.3346 46.2553 12.3033V13.2665C46.2553 13.4591 46.4094 13.631 46.6199 13.631H54.5708C54.7812 13.631 54.9354 13.4576 54.9354 13.2665V12.9375C55.6617 13.3717 56.8223 13.8222 58.4691 13.8222C60.0121 13.8222 61.2202 13.2235 61.9998 12.3596C62.4564 12.8086 63.8349 13.8222 66.3043 13.8222C69.128 13.8222 70.837 11.8262 70.837 9.848C70.837 7.23708 68.4551 6.06647 66.958 5.47079C65.4416 4.85585 64.865 4.31945 64.865 3.60819C64.865 3.08956 65.3838 2.62873 66.0745 2.62873C67.2455 2.62873 68.6477 3.68524 68.8212 3.78156C68.9946 3.9164 69.34 3.74303 69.4734 3.53113L70.4531 2.05231C70.5302 1.91747 70.5687 1.57221 70.3375 1.43737C69.7609 1.01506 68.2253 -0.00292969 66.2272 -0.00292969C64.5286 -0.00292969 63.3205 0.631276 62.5987 1.53072C62.5735 1.49516 62.5423 1.46256 62.5008 1.43737C61.9257 1.01506 60.3886 -0.00292969 58.3905 -0.00292969C56.8193 -0.00292969 55.6691 0.542368 54.9324 1.33512V0.557186C54.9324 0.364554 54.7783 0.192666 54.5678 0.192666H46.617C46.4065 0.192666 46.2523 0.366035 46.2523 0.557186V1.47441C45.0473 0.491987 43.7147 3.38883e-05 41.9716 3.38883e-05C38.131 3.38883e-05 35.0391 3.09104 35.0391 6.93036C35.0391 10.7697 38.131 13.8222 41.9716 13.8222" fill="black"/>
                                <path d="M63.7773 38.7343H61.2382V34.7453H63.4986C64.5866 34.7453 65.7872 35.5825 65.7872 36.6983C65.7872 37.8141 64.8667 38.7343 63.7787 38.7343M61.2382 27.2149H63.4141C64.4739 27.2149 65.3677 27.9958 65.3677 29.1116C65.3677 30.2274 64.4754 31.1194 63.4141 31.1194H61.2382V27.2149ZM66.678 32.7923C67.9898 32.0944 69.9153 30.5326 69.9153 28.3855C69.9153 25.4575 67.2087 23.1978 63.9166 23.1978H57.4154C57.1086 23.1978 56.8848 23.4482 56.8848 23.7282V42.1928C56.8848 42.4714 57.1086 42.7233 57.4154 42.7233H64.3346C67.6548 42.7233 70.4163 40.4635 70.4163 37.3399C70.4163 34.7735 68.1558 33.4073 66.678 32.7938" fill="black"/>
                                <path d="M30.5479 38.9193L28.9574 37.2286C28.7899 37.033 28.4268 37.033 28.2326 37.2004C27.2276 38.0658 25.8047 38.54 24.4943 38.54C21.3416 38.54 18.9981 35.9735 18.9981 32.878C18.9981 29.7826 21.3134 27.1317 24.4662 27.1317C25.8328 27.1317 27.2009 27.634 28.2326 28.5542C28.4283 28.7498 28.7351 28.7498 28.9307 28.5542L30.5479 26.8738V38.9193ZM55.7685 23.1975H52.3371C52.0302 23.1975 51.8064 23.4479 51.8064 23.728V35.0237C51.8064 36.9767 50.3271 38.5385 48.3187 38.5385C46.3102 38.5385 44.8872 36.9767 44.8872 35.0237V23.728C44.8872 23.4494 44.6634 23.1975 44.3566 23.1975H40.9252C40.6465 23.1975 40.3945 23.4479 40.3945 23.728V35.2474C40.3945 36.4521 40.6821 37.599 41.192 38.6229H34.9265V23.728C34.9265 23.4494 34.676 23.1975 34.3958 23.1975H31.0756C30.7687 23.1975 30.5449 23.4479 30.5449 23.728V25.0586C28.7899 23.6332 26.8556 22.9189 24.3239 22.9189C18.7432 22.9189 14.252 27.4102 14.252 32.9877C14.252 38.5651 18.7447 43.0001 24.3239 43.0001C26.5695 43.0001 28.7455 42.2904 30.5449 40.7923V42.1911C30.5449 42.4697 30.7687 42.7216 31.0756 42.7216H41.5655C41.8723 42.7216 42.0961 42.4711 42.0961 42.1911V40.0277C43.5458 41.8295 45.7914 42.9986 48.3172 42.9986C52.7254 42.9986 56.2962 39.4839 56.2962 35.2445V23.725C56.2962 23.4465 56.0457 23.1946 55.7655 23.1946" fill="black"/>
                                <path d="M30.5226 22.0506H31.6314C31.7248 22.0506 31.8078 21.9661 31.8078 21.8743V18.9033L33.8948 15.8019C33.9689 15.6804 33.8948 15.5322 33.7451 15.5322H32.5341C32.4496 15.5322 32.4125 15.5782 32.3844 15.6167L31.0889 17.5267L29.7934 15.6167C29.7652 15.5796 29.7193 15.5322 29.6437 15.5322H28.4327C28.283 15.5322 28.2088 15.6804 28.283 15.8019L30.3418 18.9137V21.8758C30.3418 21.9691 30.4159 22.0521 30.5197 22.0521" fill="#FF6030"/>
                                <path d="M39.6338 16.8437C40.0903 16.8437 40.5469 17.0111 40.8922 17.3194C40.9575 17.3846 41.0597 17.3846 41.125 17.3194L41.8513 16.5651C41.9254 16.491 41.9254 16.3784 41.8424 16.3043C41.2094 15.7264 40.5202 15.439 39.5878 15.439C37.7247 15.439 36.2246 16.9385 36.2246 18.8011C36.2246 20.6637 37.7247 22.1455 39.5878 22.1455C40.4179 22.1455 41.2183 21.8566 41.8527 21.2416C41.918 21.1764 41.9269 21.0549 41.8616 20.9897L41.1353 20.2162C41.079 20.151 40.9589 20.151 40.8937 20.2074C40.5587 20.4963 40.0829 20.6549 39.6457 20.6549C38.5933 20.6549 37.8106 19.7984 37.8106 18.7641C37.8106 17.7298 38.5844 16.8452 39.6368 16.8452" fill="#FF6030"/>
                                <path d="M47.0039 16.8985C47.1062 16.8985 47.1803 16.814 47.1803 16.7221V15.7071C47.1803 15.6137 47.1062 15.5308 47.0039 15.5308H43.1471C43.0448 15.5308 42.9707 15.6152 42.9707 15.7071V21.8743C42.9707 21.9676 43.0448 22.0506 43.1471 22.0506H47.0039C47.1062 22.0506 47.1803 21.9662 47.1803 21.8743V20.8593C47.1803 20.7659 47.1062 20.6829 47.0039 20.6829H44.4233V19.4249H46.5474C46.6408 19.4249 46.7238 19.3508 46.7238 19.2471V18.2321C46.7238 18.1387 46.6393 18.0557 46.5474 18.0557H44.4233V16.8999H47.0039V16.8985Z" fill="#FF6030"/>
                                <path d="M22.2945 15.5308H21.1754C21.078 15.5308 20.999 15.6097 20.999 15.7071V21.8743C20.999 21.9717 21.078 22.0506 21.1754 22.0506H22.2945C22.3919 22.0506 22.4709 21.9717 22.4709 21.8743V15.7071C22.4709 15.6097 22.3919 15.5308 22.2945 15.5308Z" fill="#FF6030"/>
                                <path d="M25.0906 22.0506H26.2083C26.3016 22.0506 26.3846 21.9661 26.3846 21.8743V16.8999H27.7172C27.8195 16.8999 27.8936 16.8155 27.8936 16.7236V15.7086C27.8936 15.6152 27.8195 15.5322 27.7172 15.5322H23.5802C23.4779 15.5322 23.4023 15.6167 23.4023 15.7086V16.7236C23.4023 16.8169 23.4765 16.8999 23.5802 16.8999H24.9128V21.8743C24.9128 21.9676 24.9973 22.0506 25.0906 22.0506Z" fill="#FF6030"/>
                                <path d="M17.6641 16.8437C18.1206 16.8437 18.5771 17.0111 18.9225 17.3194C18.9877 17.3846 19.09 17.3846 19.1552 17.3194L19.8815 16.5651C19.9556 16.491 19.9556 16.3784 19.8726 16.3043C19.2397 15.7264 18.5505 15.439 17.6181 15.439C15.7549 15.439 14.2549 16.9385 14.2549 18.8011C14.2549 20.6637 15.7549 22.1455 17.6181 22.1455C18.4482 22.1455 19.2486 21.8566 19.883 21.2416C19.9482 21.1764 19.9571 21.0549 19.8919 20.9897L19.1656 20.2162C19.1093 20.151 18.9877 20.151 18.924 20.2074C18.589 20.4963 18.1132 20.6549 17.6759 20.6549C16.6235 20.6549 15.8409 19.7984 15.8409 18.7641C15.8409 17.7298 16.6146 16.8452 17.667 16.8452" fill="#FF6030"/>
                                <path d="M52.7338 15.5309C52.6315 15.5309 52.5574 15.6153 52.5574 15.7072V19.0131H52.5485L48.831 15.436H48.5983C48.5049 15.436 48.4219 15.5101 48.4219 15.6035L48.4308 21.8729C48.4308 21.9663 48.5153 22.0493 48.6072 22.0493H49.7159C49.8182 22.0493 49.8938 21.9648 49.8938 21.8729V18.3981H49.9027L53.5831 22.0967C53.6024 22.1159 53.6765 22.1426 53.7046 22.1426H53.8529C53.9462 22.1426 54.0307 22.0685 54.0307 21.9752V15.7072C54.0307 15.6138 53.9462 15.5309 53.8529 15.5309H52.7352H52.7338Z" fill="#FF6030"/>
                                <path d="M64.419 16.8985C64.5212 16.8985 64.5953 16.814 64.5953 16.7221V15.7071C64.5953 15.6137 64.5212 15.5308 64.419 15.5308H60.5621C60.4599 15.5308 60.3857 15.6152 60.3857 15.7071V21.8743C60.3857 21.9676 60.4599 22.0506 60.5621 22.0506H64.419C64.5212 22.0506 64.5953 21.9662 64.5953 21.8743V20.8593C64.5953 20.7659 64.5212 20.6829 64.419 20.6829H61.8384V19.4249H63.9624C64.0558 19.4249 64.1388 19.3508 64.1388 19.2471V18.2321C64.1388 18.1387 64.0543 18.0557 63.9624 18.0557H61.8384V16.8999H64.419V16.8985Z" fill="#FF6030"/>
                                <path d="M68.6862 18.315H67.3077V16.8614H68.6862C69.0686 16.8614 69.3947 17.1785 69.3947 17.5697C69.3947 17.9609 69.0686 18.315 68.6862 18.315ZM70.7362 21.7809L69.4599 19.4145C70.2707 19.0885 70.8384 18.3995 70.8384 17.543C70.8384 16.4347 69.9254 15.5308 68.8078 15.5308H66.0211C65.9188 15.5308 65.8447 15.6152 65.8447 15.7071V21.8728C65.8447 21.9662 65.9188 22.0491 66.0211 22.0491H67.1298C67.2232 22.0491 67.3077 21.9647 67.3077 21.8728V19.4975H67.951L69.1902 21.9662C69.208 22.0032 69.2643 22.0506 69.3399 22.0506H70.5791C70.7377 22.0506 70.8029 21.901 70.7377 21.7809" fill="#FF6030"/>
                                <path d="M57.9427 21.8728V16.8985H59.2753C59.3776 16.8985 59.4517 16.814 59.4517 16.7221V15.7071C59.4517 15.6137 59.3776 15.5308 59.2753 15.5308H55.1383C55.036 15.5308 54.9619 15.6152 54.9619 15.7071V16.7221C54.9619 16.8155 55.036 16.8985 55.1383 16.8985H56.4709V21.8728C56.4709 21.9662 56.5553 22.0491 56.6472 22.0491H57.7649C57.8582 22.0491 57.9413 21.9647 57.9413 21.8728" fill="#FF6030"/>
                                <path d="M83.7945 14.2756H84.9996V2.08936H72.8258L71.2428 4.49726H82.5909V11.9684C78.531 12.6589 75.4005 16.7887 75.4005 21.7631C75.4005 26.7374 78.5295 30.8672 82.5909 31.5577V39.0288H72.5516L70.7373 41.4368H84.9996V29.2505H83.7945C80.4935 29.2505 77.8091 25.8913 77.8091 21.7631C77.8091 17.6348 80.495 14.2756 83.7945 14.2756Z" fill="#FF6030"/>
                                <path d="M2.40867 39.0288V31.5577C6.46857 30.8672 9.59909 26.7389 9.59909 21.7631C9.59909 16.7872 6.47005 12.6589 2.40867 11.9684V4.49726H15.8068L16.9111 2.08936H0V14.2756H1.20507C4.50606 14.2756 7.19043 17.6348 7.19043 21.7631C7.19043 25.8913 4.50606 29.2505 1.20507 29.2505H0V41.4368H16.4842L13.8784 39.0288H2.40867Z" fill="#FF6030"/>
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_5608_6179">
                                <rect width="85" height="43" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                        {{ filter.title }}
                    </span>

                    <input
                        type="checkbox"
                        :checked="filter.facets[0].isChecked"
                        @change="updateFacet(filter, filter.facets[0])"
                    >
                    <span class="calendar-filters__slider"></span>
                </label>
            </template>

        </div>
        <button @click="viewResults" class="calendar-filters__view-results btn--black">
            View {{ displayCount }} results
        </button>
        <button v-if="canReset" @click="resetFilters" class="calendar-filters__reset">
            Reset Filters
        </button>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, computed } from 'vue';
import { flatten, uniqBy, get, compact, map, debounce } from 'lodash';
import { useState } from '../services/stateful';
import Fuse from 'fuse.js';

const emit = defineEmits(['close', 'update:filteredEvents']);

const props = defineProps({
    events: {
        type: Array,
        required: true,
    },
});

const filteredEvents = useState('Calendar.FilteredEvents', []);

const FILTER_CONFIG = [
    // {
    //     name: 'genre',
    //     title: 'Genre',
    //     field: 'event.attributes.custom.genres',
    //     facets: [],
    //     isOpen: false,
    //     checkboxGroup: true,
    // },
    {
        name: 'timeOfDay',
        title: 'Time of day',
        field: 'filters.timeOfDay',
        facets: [],
        isOpen: false,
        checkboxGroup: true,
    },
    // {
    //     name: 'ticketsUnder50',
    //     title: 'Show me tickets under $50',
    //     field: 'filters.ticketsUnder50',
    //     facets: [],
    //     checkboxGroup: false,
    // },
    // {
    //     name: 'accessClub',
    //     title: 'Access Club tickets',
    //     field: 'filters.accessClub',
    //     facets: [],
    //     checkboxGroup: false,
    // }
];

const filters = ref([]);
const displayCount = ref(0);

let allPerformances = null;
let fuse = null;
let filteredPerformances = null;
let animationId = null;

const prefersReducedMotion = () => {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

const buildQuery = (appliedFacets) => {
    return compact(
        map(appliedFacets, (facets, filter) => {
            if (!facets.length) return null;

            return {
                '$and': facets.map(facet => ({
                    [filter]: facet,
                })),
            };
        })
    );
}

const setupFilters = (performances) => {
    return FILTER_CONFIG.map(filter => {
        let facets = performances.map(item => {
            if (filter.name === 'ticketsUnder50') {
                return item.filters.ticketsUnder50.length ? ['under50'] : [];
            }
            if (filter.name === 'accessClub') {
                return item.filters.accessClub.length ? ['accessClub'] : [];
            }

            const value = get(item, filter.field);
            return Array.isArray(value) ? value : (value ? [value] : []);
        });

        facets = flatten(facets);
        facets = uniqBy(facets, facet => facet);

        filter.facets = facets.map(facet => ({
            title: facet,
            isChecked: false,
            isDisabled: false,
        }));

        return filter;
    });
}

const canReset = computed(() => {
    return filters.value.some(filter =>
        filter.facets.some(facet => facet.isChecked)
    );
});

const processResults = () => {
    const appliedFacets = {};

    for (const filter of filters.value) {
        appliedFacets[filter.field] = [];

        for (const facet of filter.facets) {
            if (facet.isChecked) {
                appliedFacets[filter.field].push(facet.title);
            }
        }
    }

    const appliedQuery = buildQuery(appliedFacets);

    if (appliedQuery.length) {
        filteredPerformances = fuse.search({
            '$and': appliedQuery,
        }).map(result => result.item);
        canReset.value = true;
    } else {
        filteredPerformances = allPerformances;
        canReset.value = false;
    }

    const availableValues = {};
    filters.value.forEach(filter => {

        availableValues[filter.field] = new Set(
            filteredPerformances.flatMap(item => {
                const value = get(item, filter.field);

                if (Array.isArray(value)) {
                    return value;
                } else if (value !== undefined && value !== null) {
                    return [value];
                }
                return [];
            })
        );
    });

    filters.value = filters.value.map(filter => {
        filter.facets = filter.facets.map(facet => {
            if (!facet.isChecked) {
                facet.isDisabled = !availableValues[filter.field].has(facet.title);
            }

            return facet;
        });

        return filter;
    });

    animateCount(filteredPerformances ? filteredPerformances.length : props.events.length);

    filteredEvents.value = filteredPerformances;
};

const debouncedProcessResults = debounce(() => {
    processResults();
}, 150);

const animateCount = (targetCount) => {
    if (prefersReducedMotion()) {
        displayCount.value = targetCount;
        return;
    }

    if (animationId) {
        cancelAnimationFrame(animationId)
    }

    const startCount = displayCount.value;
    const difference = targetCount - startCount;
    const duration = 300; // ms
    const startTime = performance.now();

    const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        displayCount.value = Math.round(startCount + difference * progress);

        if (progress < 1) {
            animationId = requestAnimationFrame(animate);
        }
    };

    animationId = requestAnimationFrame(animate);
};

const viewResults = () => {
    emit('close');
};

const updateFacet = (filter, facet) => {
    facet.isChecked = !facet.isChecked;
    debouncedProcessResults();
};

const resetFilters = () => {
    filters.value = filters.value.map(filter => {
        filter.facets = filter.facets.map(facet => {
            facet.isChecked = false;
            return facet;
        });
        return filter;
    });

    processResults();
};

watch(() => props.events, (newEvents, oldEvents) => {
    if (newEvents.length === 0) return;
    if (newEvents === oldEvents) return;

    allPerformances = newEvents;

    fuse = new Fuse(allPerformances, {
        threshold: 0.3,
        useExtendedSearch: true,
        includeScore: false,
        shouldSort: false,
        keys: [
            // 'event.title',
            // 'event.attributes.custom.genres',
            'filters.timeOfDay',
            // 'event.venue.title',
            'filters.ticketsUnder50',
            'filters.accessClub',
        ],
    });

    filters.value = setupFilters(allPerformances);
    displayCount.value = allPerformances.length;
    processResults();
}, { immediate: true });

</script>
